import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { interval, SubscriptionLike } from 'rxjs';

@Component({
  selector: 'success-banertemplate',
  template: `<p class="text-success-bg fs-14 text-center m-0 py-2">
              <i class="fas fa-check-circle text-success"></i>&nbsp; {{Content.message}}
              <span class="success_close" (click)='messageClose()'>
                <i class="fas fa-times"></i>
              </span>
            </p>`,
  styles: [
  ]
})
export class SuccessBanertemplateComponent implements OnInit,OnDestroy {
  subInterval :SubscriptionLike;
  @Input() public Content: any;
  constructor(
    public ngModal: NgbActiveModal
  ) { }
  ngOnDestroy(): void {
    if(this.subInterval)
    this.subInterval.unsubscribe();
  }
  ngOnInit(): void {
    this.subInterval = interval(5 * 1000).subscribe(() => { this.messageClose(); });
  }

  messageClose() {
   this.ngModal.dismiss();
  }
}


